package one.healthium.profile.ui.weight_history

import androidx.compose.ui.util.fastForEach
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format
import kotlinx.datetime.format.char
import one.healthium.base.utils.localizedMonthNames
import kotlinx.datetime.toLocalDateTime
import one.healthium.domain.common.sameYearAsToday
import one.healthium.profile.ui.weight.WeightHistoryUiModel
import androidx.compose.runtime.Immutable

@Immutable
internal data class WeightHistoryUiState(
    val loading: Boolean = false,
    val weightHistory: List<WeightHistoryUiModel>? = null,
    val isMetric: Boolean = false,
    val deleteInProgress: Set<String> = emptySet(),
) {
    val uiData: List<Any>? = weightHistory?.let {
        val currentYearFormatter = dateFormatMonth()
        val lastYearFormatter = dateFormatMonthLastYear()
        var latestMonth: String? = null
        buildList {
            weightHistory
                .sortedByDescending { it.date }
                .filterNot { it.id in deleteInProgress }
                .fastForEach { weightHistoryUiModel ->
                    val formatter = if (weightHistoryUiModel.date.sameYearAsToday()) {
                        currentYearFormatter
                    } else {
                        lastYearFormatter
                    }
                    val month = weightHistoryUiModel.date.toLocalDateTime(TimeZone.currentSystemDefault()).format(formatter)
                    if (latestMonth != month) {
                        add(month)
                    }
                    latestMonth = month

                    add(weightHistoryUiModel)
                }
        }
    }
}

private fun dateFormatMonth() = LocalDateTime.Format {
    monthName(localizedMonthNames())
}

private fun dateFormatMonthLastYear() = LocalDateTime.Format {
    monthName(localizedMonthNames())
    char(' ')
    year()
}
